export default __webpack_public_path__ + "static/TitilliumWeb-Bold-6d6124d11999b7ca6dea808d5db13c4c.ttf";